import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { careerAndSeasonStatsNavSelector } from 'store/modules/statspro/career-and-season-stats/selectors';
import { UPDATE_NAV_ITEM } from 'store/modules/statspro/career-and-season-stats/actions';
import { STATS_CATEGORY_ARRAY } from '../../../common/config/categories';
import PropTypes from 'prop-types';

export const CategoryNavItem = ({ hideLabel = false }) => {
    const dispatch = useDispatch();
    const nav = useSelector(careerAndSeasonStatsNavSelector);

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                type="with-default"
                icon="chart"
                className="w-100"
                items={STATS_CATEGORY_ARRAY}
                itemToString={(item) => item}
                initialSelectedItem={nav.category}
                activeItem={nav.category}
                label={getTranslation('label.statsLeaders.nav.category')}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        UPDATE_NAV_ITEM.request({
                            navItem: 'category',
                            value: selectedItem
                        })
                    );
                }}
                hideLabel={hideLabel}
            />
        </div>
    );
};

CategoryNavItem.propTypes = {
    hideLabel: PropTypes.bool
};
